import { MetaTags, ZeroStatePage } from '@devd-client/devd/components';
import { useGoalsPage } from '../apis';
import GoalsPage from './devd-goals';

export const Goals = () => {
  const { data } = useGoalsPage();
  return (
    <>
      <MetaTags title="Goals | Devdynamics" />
      {data && data?.dto?.enabled ? (
        <GoalsPage data={data} />
      ) : (
        <ZeroStatePage
          data={data?.dto}
          featureAlert={data?.featureEnable === false ? true : false}
        />
      )}
    </>
  );
};

export default Goals;
